import { AccordionDetails } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledMuiAccordionDetails = styled(AccordionDetails)`
  padding: 0;
  background-color: #ffffff;
`;
